/**
 * Parses tab-separated values (TSV) handling multi-line quoted fields.
 */
export function parseTsv(text: string): string[][] {
  const clean = text.replace(/\r/g, '')
  const rows: string[][] = []
  let row: string[] = []
  let cur = ''
  let inQuotes = false

  for (let i = 0; i < clean.length; i++) {
    const ch = clean[i]
    if (inQuotes) {
      if (ch === '"') {
        if (clean[i + 1] === '"') {
          cur += '"'
          i++
        } else {
          inQuotes = false
        }
      } else {
        cur += ch
      }
    } else if (ch === '"' && cur === '') {
      inQuotes = true
    } else if (ch === '\t') {
      row.push(cur)
      cur = ''
    } else if (ch === '\n') {
      row.push(cur)
      rows.push(row)
      row = []
      cur = ''
    } else {
      cur += ch
    }
  }

  row.push(cur)
  if (row.length > 1 || row[0] !== '' || !rows.length) {
    rows.push(row)
  }

  return rows
}

/**
 * Converts a 2D matrix of values to a TSV string with Excel quoting.
 */
export function toTsv(matrix: any[][]): string {
  const quote = (val: any) => {
    const s = String(val ?? '')
    if (/[\t\n"]/.test(s)) {
      return '"' + s.replace(/"/g, '""') + '"'
    }
    return s
  }

  return matrix.map((row) => row.map(quote).join('\t')).join('\n')
}

/**
 * Exports data to CSV file with UTF-8 BOM (\uFEFF) for Vietnamese Excel support.
 */
export function exportToCsv(filename: string, headers: string[], rows: any[][]): void {
  const quote = (val: any) => '"' + String(val ?? '').replace(/"/g, '""') + '"'
  const lines = [headers.map(quote).join(',')]
  for (const row of rows) {
    lines.push(row.map(quote).join(','))
  }

  const csvContent = '\uFEFF' + lines.join('\r\n')
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
